module.exports = __webpack_public_path__ + "img/delivery.99a13b73.svg";